module.exports = __webpack_public_path__ + "static/media/upload.30be155f.svg";